export default "__VITE_ASSET__DFM5Ng9Y__"